import * as React from 'react'
import { Block } from '../Layout/Block'
import { Icon } from '$views/components/Icon'
import { SizeName } from '$utils/theme/size'
import { StyledFooterLink } from '$views/components/Footer/Footer.styles'

interface FooterLinkProps {
  href: string
  marginTop?: SizeName
}

interface FooterIconLinkProps {
  icon: string
  href: string
}

export const FooterLink: React.SFC<FooterLinkProps> = ({ href, children, marginTop }) => {
  return (
    <Block marginTop={marginTop || 'mini'}>
      <StyledFooterLink color="white" href={href} noneTextDecoration>
        {children}
      </StyledFooterLink>
    </Block>
  )
}

export const FooterIconLink: React.SFC<FooterIconLinkProps> = ({ icon, href }) => {
  return (
    <Icon
      content={icon}
      size="m"
      clickable
      onClick={() => (window.location.href = href)}
      marginLeft="base"
      marginRight="base"
    />
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Footer/FooterLink.tsx